module.exports = __webpack_public_path__ + "static/media/cactus.340b4698.png";